import { render, staticRenderFns } from "./Error.vue?vue&type=template&id=346ca75e&scoped=true&"
import script from "./Error.vue?vue&type=script&lang=js&"
export * from "./Error.vue?vue&type=script&lang=js&"
import style0 from "./Error.vue?vue&type=style&index=0&id=346ca75e&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "346ca75e",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/www/stage-dev2/front/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('346ca75e')) {
      api.createRecord('346ca75e', component.options)
    } else {
      api.reload('346ca75e', component.options)
    }
    module.hot.accept("./Error.vue?vue&type=template&id=346ca75e&scoped=true&", function () {
      api.rerender('346ca75e', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/auth/Error.vue"
export default component.exports